'use strict'

export const TIMING = {
  base: 150,
  ratio: 1.333,
  unit: 'ms',
  subSequence: true
}
